import Styles from "./ChaseController.module.scss";
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import Recorder from "../../components/Recorder/Recorder";
import axios from "axios";
import MultiChoiceSelectionButton from "../../components/AnswerButton/MultiChoiceSelectionButton";
import WaitingGraphic from "../../components/WaitingGraphic/WaitingGraphic";
import HeadingBox from "../../components/HeadingBox/HeadingBox";
import ProfileEntry from "../../components/ProfileEntry/ProfileEntry";
import BasicButton from "../../components/BasicButton/BasicButton";
import NoSleep from "nosleep.js"
import buttonBackgroundBlue from "assets/images/chase/Chase_PlayerLockedIn_Background.png";
import chevron from "assets/images/chase/chevron.png";
import IconButton from "../../components/IconButton/IconButton";

const ChaseController = () => {
    const [roomId, setRoomId] = useState("")
    const [clientId, setClientId] = useState("")
    const [connectionStatus, setConnectionStatus] = useState("disconnected")
    const [error, setError] = useState(null)
    const [recordedAudio, setRecordedAudio] = useState("");
    const [waitingToJoin, setWaitingToJoin] = useState(false);
    const [waitingForTranscription, setWaitingForTranscription] = useState(false);
    const server = useRef(null)
    const gameStateRef = useRef(null); // Create ref for gameState
    const [isRecording, setIsRecording] = useState(false);
    const noSleep = useRef(new NoSleep());
    const roomIdInput = useRef(null);

    const testState = {
        "state": "ProfileSelection",
        "cash": 0,
        "chasersoffers": [
            1000,
            500,
            200
        ],
        "currentquestiondata": {
            "Id": 800,
            "DisplayQuestion": "What type of forecast traditionally follows TV news bulletins?",
            "DisplayAnswer": "Weather forecast",
            "DifficultyRating": "Easy",
            "CategoryId": 34,
            "Category": {
                "Id": 34,
                "Name": "PotLuck",
                "DisplayName": "Pot Luck"
            },
            "PosibleAnswers": [
                {
                    "Text": "Weather forecast",
                    "Score": 0
                }
            ],
            "Keywords": [
                {
                    "Text": "Weather",
                    "Weight": 1
                },
                {
                    "Text": "forecast",
                    "Weight": 1
                }
            ],
            "RecognitionThreshold": 1.01,
            "multiChoiceAnswers": [
                { "text": "The Silver Chair", "isCorrect": false },
                { "text": "The Magician's Nephew", "isCorrect": false },
                { "text": "The Lion, The Witch and The Wardrobe", "isCorrect": true }

            ],
            "ContentType": "Text",
            "AnswerType": "Any",
            "QuestionVoUrl": "https://play360.blob.core.windows.net/play360-resources/vo/questions/800/QuestionVoUrl.wav",
            "AnswerVoUrl": "https://play360.blob.core.windows.net/play360-resources/vo/questions/800/AnswerVoUrl.wav",
            "MultiChoiceQuestionVoUrl": "https://play360.blob.core.windows.net/play360-resources/vo/questions/800/MultiChoiceQuestionVoUrl.wav",
            "Tags": []
        },
        "rendergraphic": true,
        "ispaused": false,
        "ispausable": true,
        "transcriptionstate": "idle",
        "videoplaying": true,
        "inputtype": "inputfield"
    }

    //const [gameState, setGameState] = useState(testState); // FOR TESTING
    const [gameState, setGameState] = useState(); // FOR LIVE
    gameStateRef.current = gameState;


    useEffect(() => {
        const enableNoSleep = () => {
            noSleep.current.enable();
        };

        document.addEventListener("click", enableNoSleep, { once: true });

        return () => {
            noSleep.current.disable();
            document.removeEventListener("click", enableNoSleep);
        };
    }, []);

    useEffect(() => {
        gameStateRef.current = gameState; // Update ref whenever question changes
    }, [gameState]);


    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const roomId = query.get("roomId");
        const sanitisedRoomId = roomId ? roomId.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 4) : "";
        setRoomId(sanitisedRoomId);
        if (roomIdInput.current) roomIdInput.current.value = sanitisedRoomId;
        console.log("roomId: " + sanitisedRoomId);
        if (sanitisedRoomId && roomId.length == 4) connect(sanitisedRoomId);
    }, []);

    const connect = (roomId) => {
        const ws = new WebSocket(process.env.REACT_APP_WS_SERVER);
        server.current = ws;
        setWaitingToJoin(true);
        setError(null);
        setConnectionStatus("connecting");
        ws.onopen = () => {
            console.log("connected");
            const message = {
                type: "join_room",
                roomId: roomId
            }
            setConnectionStatus("joining_room");
            ws.send(JSON.stringify(message));
        };

        ws.onmessage = (event) => {
            if (!event.data) {
                console.log("Message had no data");
                return;
            }

            const message = JSON.parse(event.data);
            switch (message.type) {
                case "connected":
                    console.log("your ID: " + message.client_id);
                    setClientId(message.client_id);
                    break;
                case "room_joined":
                    setConnectionStatus("connected");
                    console.log("room %s joined", roomId);
                    setGameState(message.state);
                    setWaitingToJoin(false);
                    const url = new URL(window.location.href);
                    url.searchParams.set("roomId", roomId);
                    window.history.replaceState({}, "", url);
                    checkMicPermission();
                    break;
                case "join_room_failed":
                    console.log("room join error");
                    setConnectionStatus("connected - failed to join room");
                    setWaitingToJoin(false);
                    setError("Failed to join room");
                    break;
                case "error":
                    setError(message.error);
                    console.log(message.error);
                    break;
                case "state_change":
                    setGameState(message.state);
                    console.log(message.state)
                    break;
                case "set_profiles":
                    setProfiles(message.profiles);
                    console.log(message.profiles);
                    break;
                default:
                    console.log("unknown message type: " + event.data);
                    break;
            }
        };

        ws.onclose = (event) => {
            console.log("disconnected");
            console.log(event);
            setConnectionStatus("disconnected");
            setWaitingToJoin(false);
        }
    }

    const checkMicPermission = async () => {
        try {
            await navigator.mediaDevices.getUserMedia({ audio: true });
            console.log("Microphone permission granted");
        } catch (error) {
            console.error("Microphone permission denied:", error);
        }
    }


    //const sendMessage = (e) => {
    //    e.preventDefault();

    //    const form = e.target;
    //    const formData = new FormData(form);
    //    const message = formData.get("message");

    //    console.log("button clicked");
    //    server.current.send(JSON.stringify({ type: "broadcast", message: message }));
    //}

    const MAX_RETRIES = 3;
    const TIMEOUT_MS = 15000 // adjust as needed

    async function transcribeAudio(question, base64Audio) {
        setWaitingForTranscription(true);
        setGameState(prev => ({ ...prev, transcriptionstate: "transcribing" }));

        const url = process.env.REACT_APP_API_URL + "/dg/transcribe";
        const body = JSON.stringify({ question, audio_base64: base64Audio });

        let lastError;
        for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);

            try {
                console.log(`Transcribing attempt ${attempt}:`, body);

                const response = await axios.post(
                    url,
                    body,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "c1aed386d72e43b5a48852e68c57b5e0",
                        },
                        signal: controller.signal,
                    }
                );

                clearTimeout(timeout);
                console.log("Transcription:", response);

                setWaitingForTranscription(false);
                setGameState(prev => ({ ...prev, transcriptionstate: "idle" }));
                return response.data;

            } catch (err) {
                clearTimeout(timeout);
                lastError = err;

                if (axios.isCancel(err)) {
                    console.warn(`Transcription attempt ${attempt} timed out after ${TIMEOUT_MS}ms`);
                } else {
                    console.warn(`Transcription attempt ${attempt} failed:`, err.message);
                }

                if (attempt < MAX_RETRIES) {
                    await new Promise(res => setTimeout(res, 500));
                }
            }
        }

        // retries exhausted → let handleRecordingEnd broadcast failure
        setWaitingForTranscription(false);
        throw lastError;
    }


    const handleRecordingEnd = async (base64Audio) => {
        setRecordedAudio(base64Audio);

        // Notify game that recording ended
        const recordingEndMsg = {
            type: "broadcast",
            message: { type: "recording_end", client: clientId }
        };
        server.current.send(JSON.stringify(recordingEndMsg));

        try {
            const data = await transcribeAudio(gameStateRef.current.currentquestiondata, base64Audio);

            const message = {
                type: "broadcast",
                message: {
                    type: "answer",
                    data: { deepgramResult: data }
                }
            };
            server.current.send(JSON.stringify(message));

        } catch (err) {
            console.error("Final transcription failure:", err);

            const failMessage = {
                type: "broadcast",
                message: {
                    type: "answer_failed",
                    client: clientId,
                    error: err.message || "transcription_failed"
                }
            };
            server.current.send(JSON.stringify(failMessage));
        } finally {
            setIsRecording(false);
        }
    };

    useEffect(() => {

        if (!gameStateRef.current) return; 

        if (gameState.transcriptionstate === "retry") {
            let cancelled = false;

            const runRetry = async () => {
                console.log("Retrying transcription...");
                if (recordedAudio) {
                    try {
                        await handleRecordingEnd(recordedAudio);
                    } catch (err) {
                        console.error("Retry failed:", err);
                    }
                }
                if (!cancelled) {
                    setGameState(prev => ({
                        ...prev,transcriptionstate: "idle"
                    }));
                }
            };

            runRetry();

            return () => { cancelled = true; };
        }
    }, [gameState?.transcriptionstate, recordedAudio]);

    const handleStartRecording = () => {
        setIsRecording(true);
        console.log("Recording started");
        const message = {
            type: "broadcast",
            message: { type: "recording", client: clientId }
        }
        server.current.send(JSON.stringify(message));
    }



    const handleAnswerClicked = (answer) => {
        const message = {
            "type": "broadcast",
            "message": {
                "type": "answer",
                "data": {
                    "selected": answer
                }
            }
        }
        server.current.send(JSON.stringify(message));
    }

    const handleSkipVideo = () => {
        const message = {
            "type": "broadcast",
            "message": {
                "type": "skip"
            }
        }
        server.current.send(JSON.stringify(message));
    }

    const handleSubmitName = (name) => {
        console.log("name submitted ", name)

        const message = {
            "type": "broadcast",
            "message": {
                "type": "text_submitted",
                "text": name
            }
        }

        server.current?.send(JSON.stringify(message))
    }

    const handleCancelName = () => {
        console.log("name cancelled")

        const message = {
            "type": "broadcast",
            "message": {
                "type": "text_cancelled"
            }
        }

        server.current?.send(JSON.stringify(message))

    }

    const renderView = () => {
        const gameState = gameStateRef.current;


        if (!gameState)
            return JoinRoomView();

        if (gameState.rendergraphic === false) {
            if (gameState.videoplaying === true) {
                return <SingleButtonView onClick={handleSkipVideo} />;
            }
            return WaitingView();

        }

        switch (gameState.state) {
            case "ProfileSelection":
                return <ChangeProfileView className={Styles.ChangeProfileView}
                    onNavigation={handleGamepadNavigation}
                    onSubmit={handleGamepadSubmit}
                    heading={"PROFILE SELECTION"}
                    inputType={gameState.inputtype}
                    onCancelName={handleCancelName}
                    onSubmitName={handleSubmitName }
                />
            case "ProfileProgress":
                return <NavigationView onNavigation={handleGamepadNavigation} onSubmit={handleGamepadSubmit} heading={"PROFILE PROGRESS"} />
            case "CashBuilder":
                return <RecorderView
                    handleRecordingEnd={handleRecordingEnd}
                    handleStartRecording={handleStartRecording}
                    waitingForTranscription={waitingForTranscription}
                />
            case "FinalChase":
                return <RecorderView
                    handleRecordingEnd={handleRecordingEnd}
                    handleStartRecording={handleStartRecording}
                    waitingForTranscription={waitingForTranscription}
                />
            case "Chase":
                return <AnswersView question={gameState.currentquestiondata} onClick={handleAnswerClicked} />;
            case "ChooseChase":
                return <CashTreeView
                    highOffer={gameState.chasersoffers[0]}
                    cash={gameState.chasersoffers[1]}
                    lowOffer={gameState.chasersoffers[2]}
                    onClick={handleAnswerClicked}
                />;
            case "HomeScene":
                return <NavigationView onNavigation={handleGamepadNavigation} onSubmit={handleGamepadSubmit} heading={"PLAY"} />
            case "GameOver":
                return <NavigationView onNavigation={handleGamepadNavigation} onSubmit={handleGamepadSubmit} heading={"GAME OVER"} />
            //return <GameOverView onMainMenuClick={GoToMainMenu} onPlayAgainClick={PlayGame} />;
            case "StudioIntro":
            case "ChaserIntro":
            case "FinalChaseIntro":
                return <SingleButtonView onClick={handleSkipVideo} />;
            case "StoreLandingPage":
                return <NavigationView onNavigation={handleGamepadNavigation} onSubmit={handleGamepadSubmit} heading={"THE CHASE"} />
            default:
                return;
        }
    }


    const handleGamepadNavigation = (navigation) => {

        console.log("ChaseController >> Received nav", navigation);

        const message = {
            "type": "broadcast",
            "message": {
                "type": "navigation",
                "direction": navigation
            }
        }

        console.log("ChaseController >> SendingMessage >> ", JSON.stringify(message))


        server.current?.send(JSON.stringify(message));

    }

    const handleGamepadSubmit = () => {
        console.log("ChaseController >> Received Submit");

        const message = {
            "type": "broadcast",
            "message": {
                "type": "submit",
            }
        }

        console.log("ChaseController >> SendingMessage >> ", JSON.stringify(message))
        server.current.send(JSON.stringify(message));
    }

    const PlayGame = () => {
        const message = {
            "type": "broadcast",
            "message": {
                "type": "play",
            }
        }
        server.current.send(JSON.stringify(message));
    }

    const ChangeProfile = () => {

        console.log("Change Profile clicked");

        const message = {
            "type": "broadcast",
            "message": {
                "type": "change_profile"
            }
        }

        server.current.send(JSON.stringify(message));
    }

    const ViewProgress = () => {
        console.log("View Progress clicked");

        const message = {
            "type": "broadcast",
            "message": {
                "type": "view_progress"
            }

        }

        server.current.send(JSON.stringify(message));
    }

    const GoToMainMenu = () => {
        const message = {
            "type": "broadcast",
            "message": {
                "type": "main_menu",
            }
        }
        server.current.send(JSON.stringify(message));
    }

    const onRoomIdInputChange = (e) => {
        var sanitised = e.target.value.toUpperCase()
        sanitised = sanitised.replace(/[^A-Z0-9]/g, '')
        sanitised = sanitised.substring(0, 4)
        setRoomId(sanitised);
        roomIdInput.current.value = sanitised
    }

    const renderPauseButton = () => {
        const gameState = gameStateRef.current;

        if (!gameState || gameState.rendergraphic === false)
            return;
        var statesToShow = ["CashBuilder", "FinalChase", "Chase"]

        if (!statesToShow.includes(gameState.state))
            return;

        return <button className={Styles.PauseButton} onClick={() => { pauseGame(true) }}><i className={Styles.Cog} /></button>;
    }

    const JoinRoomView = () => {
        return (
            <div className={Styles.JoinScreen}>

                <div className={Styles.JoinBox}>
                    <div className={Styles.Join_WhiteBorder}>
                        <div className={Styles.Join_BlueBorder}>
                            <div className={Styles.Join_MetallicGradient}>
                                <div className={Styles.Join_InnerGradient}>
                                    <p className={Styles.JoinHeading}>JOIN GAME</p>
                                    <p className={Styles.JoinSubHeading}>Enter room code on you TV in the box below...</p>
                                    <input ref={roomIdInput} type="text" name="roomId" placeholder="Room ID" onChange={(e) => onRoomIdInputChange(e)} />
                                    <button className={Styles.Button} onClick={() => connect(roomId)} disabled={waitingToJoin || !roomId || roomId.length < 4}>{waitingToJoin ? "Joining..." : "Join Room"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    error && <div className={Styles.ErrorContainer}>
                        <p className={Styles.Text}>Error: {error}</p>
                    </div>
                }



                {/*<div className={Styles.Box}>*/}
                {/*    <input ref={roomIdInput} type="text" name="roomId" placeholder="Room ID" onChange={(e) => onRoomIdInputChange(e)} />*/}
                {/*    <button className={Styles.Button} onClick={() => connect(roomId)} disabled={waitingToJoin || !roomId || roomId.length < 4}>{waitingToJoin ? "Joining..." : "Join Room"}</button>*/}
                {/*</div>*/}
                {/*{*/}
                {/*    error && <div className={Styles.ErrorContainer}>*/}
                {/*        <p className={Styles.Text}>Error: {error}</p>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>

        )
    }

    const renderHeading = () => {

        const gameState = gameStateRef.current;

        if (!gameState || gameState.rendergraphic === false) {
            return;
        }
        switch (gameState.state) {
            case "CashBuilder":
                return <HeadingView content={isRecording ? "RECORDING..." : "HOLD TO RECORD"}
                    isRecording={isRecording} />
            case "FinalChase":
                return <HeadingView content={"HOLD TO RECORD"} />
            case "Chase":
                return <HeadingView content={"SELECT ANSWER"} />
            case "ChooseChase":
                return <HeadingView content={"SELECT OFFER"} />
            default:
                return;
        }
    }

    const pauseGame = (pause) => {
        const message = {
            "type": "broadcast",
            "message": {
                "type": "pause",
                "data": pause
            }
        }
        server.current?.send(JSON.stringify(message))
        setGameState({ ...gameState, ispaused: pause })
    }

    return (
        <div className={`${Styles.Background} ${Styles.Blue}`}>
            <div className={`${Styles.Background} ${Styles.Red} ${isRecording && Styles.Show}`} />
            {
                gameState?.ispaused &&

                <div className={Styles.PauseScreen}>

                        <div className={Styles.PauseBox}>
                            <div className={Styles.Pause_WhiteBorder}>
                                <div className={Styles.Pause_BlueBorder}>
                                    <div className={Styles.Pause_MetallicGradient}>
                                        <div className={Styles.Pause_InnerGradient}>
                                            <p className={Styles.PausedHeading}>PAUSED</p>
                                            <button className={Styles.Button} onClick={() => { pauseGame(false) }}>Resume</button>
                                            <button className={Styles.Button} onClick={() => { GoToMainMenu() }}>Menu</button>
                                        </div>
                                    </div>
                                </div>  
                            </div>      
                        </div>




                    {/*<div className={`${Styles.Box} ${Styles.Blue}`}>*/}
                    {/*        <p className={Styles.Text}>Paused</p>*/}
                    {/*        <button className={Styles.Button} onClick={() => { pauseGame(false) }}>Resume</button>*/}
                    {/*        <button className={Styles.Button} onClick={() => { GoToMainMenu() }}>Menu</button>*/}
                    {/*</div>*/}
                </div>
            }
            <div className={Styles.Vignette}>
                <div className={Styles.ChaseController}>
                    <div className={Styles.ChaseControllerGradient} />
                    <div className={Styles.Header}>
                        <img className={Styles.Logo} src={"../img/Chase_Logo.svg"} alt={"Logo"} />
                    </div>

                    {renderPauseButton()}
                    {renderHeading()}
                    {renderView()}

                    <div className={Styles.RoomStatusContainer}>
                        <div className={Styles.RoomStatus_WhiteBorder}>
                            <div className={Styles.RoomStatus_BlueBorder}>
                                <div className={Styles.RoomStatus_MetallicGradient}>
                                    <div className={Styles.RoomStatus_InnerGradient}>
                                        <p className={Styles.RoomInfoLabel}>{connectionStatus === "connected" ? roomId : waitingToJoin ? "Joining..." : "No Connection"}</p>
                                        <div
                                            className={`${Styles.ConnectionStatusDot} ${connectionStatus === "connected" ? Styles.connected : waitingToJoin ? Styles.Joining : ""}`} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

//VIEWS 
const WaitingView = () => {
    return <div className={Styles.WaitingView}>
        <WaitingGraphic />
    </div>
}
const HeadingView = ({ content, isRecording }) => {
    return <HeadingBox className={Styles.HeadingView} content={content} isRecording={isRecording}
        type={"subHeading"} />
}

const CashTreeView = ({ lowOffer, cash, highOffer, onClick }) => {
    return <div className={Styles.AnswerButtonsWrapper}>
        <div className={Styles.AnswerButtons_WhiteBorder}>
            <div className={Styles.AnswerButtons_BlueBorder}>
                <div className={Styles.AnswerButtons_MetallicGradient}>
                    <div className={Styles.AnswerButtons_InnerGradient}>
                        <MultiChoiceSelectionButton buttonType={"cash"} onClick={onClick} answer={highOffer} index={0} fontSize={2.5} />
                        <MultiChoiceSelectionButton buttonType={"cash"} onClick={onClick} answer={cash} index={1} fontSize={2.5} />
                        <MultiChoiceSelectionButton buttonType={"cash"} onClick={onClick} answer={lowOffer} index={2} fontSize={2.5} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

const SingleButtonView = ({ onClick }) => {
    return <div className={Styles.AnswerButtonsWrapper}>
        <button className={Styles.SkipButton} onClick={onClick}>SKIP VIDEO</button>
    </div>
}



const AnswersView = ({ question, onClick }) => {
    const [fontSize, setFontSize] = useState(50); // initial large font
    const containerRefs = useRef([]); // refs to children <p> containers

    // Run after initial render to measure children
    useLayoutEffect(() => {
        if (!containerRefs.current || containerRefs.current.length === 0) return;

        const minFontSize = 10; // px
        const maxFontSize = 50; // px
        const BUFFER = 15; // px

        let low = minFontSize;
        let high = maxFontSize;
        let bestFit = minFontSize;

        const fitsAll = (sizePx) => {
            return containerRefs.current.every((container) => {
                if (!container) return true;

                const textEl = container.querySelector(".AnswerText");
                const letterEl = container.querySelector(".AnswerLetter");
                if (!textEl) return true;

                // temporarily apply test size in px
                textEl.style.fontSize = `${sizePx}px`;

                const totalWidth =
                    textEl.scrollWidth + (letterEl ? letterEl.offsetWidth : 0) + BUFFER;

                return (
                    totalWidth <= container.clientWidth &&
                    textEl.scrollHeight <= container.clientHeight
                );
            });
        };

        // Binary search for largest size that fits
        while (low <= high) {
            const mid = Math.floor((low + high) / 2);
            if (fitsAll(mid)) {
                bestFit = mid;
                low = mid + 1;
            } else {
                high = mid - 1;
            }
        }

        // convert back to em (relative) if you want
        setFontSize(bestFit / 16); // assumes root font-size = 16px
    }, [question]);


    return (
        <div className={Styles.AnswerButtonsWrapper}>
            <div className={Styles.AnswerButtons_WhiteBorder}>
                <div className={Styles.AnswerButtons_BlueBorder}>
                    <div className={Styles.AnswerButtons_MetallicGradient}>
                        <div className={Styles.AnswerButtons_InnerGradient}>
                            {question.multiChoiceAnswers.map((ans, i) => (
                                <MultiChoiceSelectionButton
                                    key={i}
                                    buttonType="answer"
                                    onClick={onClick}
                                    answer={ans.text}
                                    index={i}
                                    fontSize={fontSize}
                                    setContainerRef={(el) => (containerRefs.current[i] = el)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};




const RecorderView = ({ handleRecordingEnd, handleStartRecording, waitingForTranscription }) => {

    return <div className={Styles.RecorderWrapper}>
        <Recorder onRecordingEnd={handleRecordingEnd}
            onStartRecording={handleStartRecording}
            disabled={waitingForTranscription} />
    </div>
}

const HomeSceneView = ({ onPlayClick, onChangeProfileClick, onViewProgressClick }) => {
    return <div className={Styles.HomeSceneView}>
        <BasicButton onClick={onPlayClick} label={'Play'} alt={'Play'} />
        <BasicButton onClick={onChangeProfileClick} label={'Change Profile'} alt={'Profile'} />
        <BasicButton onClick={onViewProgressClick} label={'View Progress'} alt={'Progress'} />
    </div>
}

const GameOverView = ({ onPlayAgainClick, onMainMenuClick }) => {
    return <div className={Styles.HomeSceneView}>

        <BasicButton onClick={onPlayAgainClick} label={'Play Again'} alt={'Play'} />
        <BasicButton onClick={onMainMenuClick} label={'Menu'} alt={'Menu'} />

    </div>
}

const NavigationView = ({ onNavigation, onSubmit, heading }) => {

    const handleInputDirection = (direction) => {

        const navigationMap = {
            "up": { x: 0, y: 1 },
            "down": { x: 0, y: -1 },
            "left": { x: -1, y: 0 },
            "right": { x: 1, y: 0 }
        }

        let nav = navigationMap[direction]
        console.log("received navigation", nav)

        onNavigation(nav);

    }

    const handleInputSubmit = () => {
        console.log("received submit")
        onSubmit();
    }

    return (
        <div className={Styles.ChangeProfileView}>
            <span className={Styles.Heading}>{heading}</span>
            <div className={Styles.GamePad}>
                <div className={Styles.Up}><IconButton onClick={() => handleInputDirection("up")} alt={"up"} icon={chevron} rotation={"up"} type={"icon"} /></div>
                <div className={Styles.Down}><IconButton onClick={() => handleInputDirection("down")} alt={"down"} icon={chevron} rotation={"down"} type={"icon"} /></div>
                <div className={Styles.Left}><IconButton onClick={() => handleInputDirection("left")} alt={"left"} icon={chevron} rotation={"left"} type={"icon"} /></div>
                <div className={Styles.Right}><IconButton onClick={() => handleInputDirection("right")} alt={"right"} icon={chevron} rotation={"right"} type={"icon"} /></div>
                <div className={Styles.Center}><IconButton onClick={() => handleInputSubmit()} type={"text"} text={"OK"} /></div>
            </div>
        </div>
    )

}

const ChangeProfileView = ({ inputType, onNavigation, onSubmit,heading, onSubmitName, onCancelName }) => {

    const [profileName, setProfileName] = useState("");
    const characterLimit = 10;


    const handleNameChange = (e) => {
        var sanitised = e.target.value.toUpperCase()
        if (sanitised.length >= characterLimit ) {
            sanitised = sanitised.slice(0, characterLimit);
        }
        setProfileName(sanitised);
    }

    const submitName = () => {
        onSubmitName(profileName);
    }

    const cancelName = () => {
        onCancelName();
    }

    const renderView = () => {
        console.log("rendering view: ", inputType)
        switch (inputType) {
            case "navigation":
                return <NavigationView onNavigation={onNavigation} onSubmit={onSubmit} heading={heading} />
            case "inputfield":
                return <div className={Styles.TextInputContainer}>
                    <input type="text" name="profileName" placeholder="Enter new profile name" onChange={(e) => handleNameChange(e)} maxLength={characterLimit} />
                    <div className={Styles.ButtonsContainer}>
                        <button className={Styles.Button} onClick={submitName}>SUBMIT</button>
                        <button className={Styles.Button} onClick={cancelName}>CANCEL</button>
                    </div>
                </div>
        }
    }

    return (
        <>
            {renderView() }
        </>
    )
    

}


export default ChaseController;

